import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useRequestCtc } from 'all-in-one-shared-api';

import { MessageType } from 'models/MessageType';

import ClaimDetailsModal, { ClaimDetailsModalProps } from '../ClaimDetailsModal';

interface ClaimCopyModalProps extends Pick<ClaimDetailsModalProps, 'visible' | 'setVisibility'> {
  claimId: string;
  authToken: string;
  sequenceNo?: number;
  onSuccess?: () => void;
  onFail?: () => void;
}

export const ClaimCopyModal = ({
  visible,
  setVisibility,
  claimId,
  sequenceNo,
  authToken,
  onSuccess,
  onFail,
}: ClaimCopyModalProps): JSX.Element => {
  const { t } = useTranslation();

  const { shouldFetch, isLoading } = useRequestCtc(
    { name: 'useRequestCtc', params: { claimId, sequenceNo } },
    authToken,
    claimId,
    sequenceNo,
    {
      onSuccess: () => {
        message[MessageType.SUCCESS](t('claimDetails.ctcReceiptRequested'));
        onSuccess?.();
        closeModal();
      },
      onError: () => {
        message[MessageType.ERROR](t('common.error.generic'));
        onFail?.();
        closeModal();
      },
    },
  );
  const closeModal = () => {
    shouldFetch(false);
    setVisibility(false);
  };

  const handleReturnCopy = () => {
    shouldFetch(true);
  };

  return (
    <ClaimDetailsModal
      visible={visible}
      setVisibility={setVisibility}
      handleOk={handleReturnCopy}
      modalLoading={isLoading}
      title={t('claimDetails.areYouSureToRequestReturnTrueCopy')}
      description={t('claimDetails.youCanOnlyRequestOnce')}
    />
  );
};
